const EmailVeification = {
  path: '/email-verification/:id',
  name: 'email-verification',
  component: () => import('../views/Auth/EmailVerification.vue'),
};

module.exports = {
  EmailVeification,
};
